namespace $ {
	export class $shm_hitalama_guide_github extends $shm_hitalama_components_github {
		override async read( repository: string, token: string, revision = 0 ) {
			const remote = await super.read( repository, token, revision )
			if( remote.private !== true ) throw new Error( 'Репозиторий руководства должен быть закрытым.' )
			return remote
		}
		static catalogue_files( catalog: $shm_hitalama_guide_catalog ) {
			const files: Record<string, string> = {}, pages: Record<string, $shm_hitalama_guide_document_data> = {}
			for( const id of catalog.ids() ) {
				this.$.$shm_hitalama_guide_catalog.slug( id )
				const page = catalog.page( id )!.read()
				catalog.validate_links( page.links )
				catalog.validate_links( this.$.$shm_hitalama_guide_markdown.references(this.$.$shm_hitalama_guide_markdown.text(page)).map(page=>({page,title:page})) )
				pages[id] = {...page,parent:catalog.page(id)!.parent()}
				files[id + '.md'] = this.$.$shm_hitalama_guide_markdown.text( page ) + '\n'
			}
			const groups = Object.fromEntries( catalog.groups().sort().map( id => [id, { title: catalog.group(id)!.title(), parent: catalog.group(id)!.Parent()?.val() ?? '' }] ) )
			const orders=Object.fromEntries([...(catalog.tree()).entries()].filter(([id])=>!id||catalog.group(id)))
			files['guide.json'] = JSON.stringify({ pages, groups, orders, sections: Object.fromEntries( ( catalog.Sections()?.keys() ?? [] ).map( key => [ key, catalog.Sections()!.key( key )!.val() ] ) ) }, null, '\t' ) + '\n'
			files['.hitalama.json'] = JSON.stringify({ format: 1, kind: 'guide', catalog: catalog.link().str, files: Object.keys( files ).sort() }, null, '\t' ) + '\n'
			return files
		}
		override commit_message( files: Record<string, string> ) { return 'Update user guide' }
		override async changes( repository: string, token: string, snapshot: string, remote: $shm_hitalama_components_github_state | null ) {
			const files = JSON.parse( snapshot ), manifest = JSON.parse( files['.hitalama.json'] ), hashes = await this.hashes( snapshot )
			if( manifest.kind !== 'guide' || manifest.format !== 1 ) throw new Error( 'Некорректный формат руководства.' )
			const removed: string[] = []
			if( remote?.files['.hitalama.json'] ) {
				const previous = await this.metadata( repository, token, remote.files['.hitalama.json'] )
				if( previous.kind !== 'guide' || previous.format !== 1 || previous.catalog !== manifest.catalog || !Array.isArray( previous.files ) ) throw new Error( 'Репозиторий принадлежит другому каталогу.' )
				if( !remote.files['guide.json'] ) throw new Error( 'В репозитории отсутствует описание страниц руководства.' )
				const index = await this.metadata( repository, token, remote.files['guide.json'] )
				if( !index.pages || typeof index.pages !== 'object' || Array.isArray( index.pages ) ) throw new Error( 'Некорректное описание страниц руководства.' )
				for( const path of previous.files ) {
					if( typeof path !== 'string' ) throw new Error( 'Некорректный путь руководства.' )
					if( path !== 'guide.json' ) { if( !path.endsWith( '.md' ) ) throw new Error( 'Некорректный путь руководства.' ); const id = path.slice( 0, -3 ); this.$.$shm_hitalama_guide_catalog.slug( id ); if( !Object.hasOwn( index.pages, id ) ) throw new Error( 'Файл не принадлежит страницам руководства.' ) }
					if( !( path in files ) && path in remote.files ) removed.push( path )
				}
			}
			return { changed: Object.keys( hashes ).filter( path => hashes[path] !== remote?.files[path] ), removed }
		}
	}
}
